import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { StandaloneBaseComponent } from 'projects/shared/lib/components/standalone/base/standalone-base.component';
import { EContentLocation } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';

@Component({
    template: '',
    standalone: false
})
export class ContentPageBaseComponent extends StandaloneBaseComponent implements OnInit, OnDestroy {
  private queryParamSubscription: Subscription | undefined;

  public parent: string | undefined;
  public eContentLocation: typeof EContentLocation;
  private activatedRoute: ActivatedRoute;

  public constructor() {
    super();
    this.activatedRoute = ServiceLocator.injector.get(ActivatedRoute);
    this.eContentLocation = EContentLocation;
  }

  public ngOnInit(): void {
    if (!this.queryParamSubscription) {

      this.queryParamSubscription = this.activatedRoute.queryParams.subscribe(
        (queryParams: Params) => {
          let errorList: string[] = [];

          let parent = queryParams.parent;
          if (!parent) {
            errorList.push("content page base - parent missing");
          }

          if (errorList.length > 0) {
            errorList.forEach(
              (errorString: string) => {
                this.logger.error(`${errorString}`, this.constructor.name);
              }
            );
            return;
          }

          this.parent = parent;

          this.titleSet(parent);
          this.metaDescriptionSet([{ key: "page", value: parent }]);

        }
      );
    }
  }

  public ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }

}
